import {
  RECEIVE_VIDEOS_URLS,
  REMOVE_EVENT_VIDEO,
  RECEIVE_STICKERS_URL,
  REMOVE_EVENT_STICKER,
  REORDER_EVENT_STICKER,
} from '../../constants/ActionTypes';
import editEventContent from '../../functions/event/editEventContent';
import { findEvent, copyQuest, touchQuestModified } from '../questsHelpers';

/**
 * Handles video and sticker event actions.
 * @param {Object} state - current state of quests slice
 * @param {Object} action - dispatched Redux action
 * @returns {Object|null}
 */
export default function eventVideoStickerReducer(state, action) {
  let nextQuest;

  switch (action.type) {
    case RECEIVE_VIDEOS_URLS: {
      const targetQuest = (state.quests || []).find(
        (quest) => String(quest.id) === String(action.questId)
      );
      if (!targetQuest) return state;
      nextQuest = { ...targetQuest };
      const event = (nextQuest.events || []).find(
        (e) => String(e.id) === String(action.eventId)
      );
      if (!event) return state;
      const video = {
        contentType: 'video',
        visible: true,
        data: action.payload,
      };
      if (!event.content) {
        event.content = [video];
      } else {
        const currentVideos = event.content.filter(
          (item) => item.contentType === 'video'
        );
        if (currentVideos.length) {
          const [videoItem] = currentVideos;
          event.content = event.content.filter(
            (item) => item.contentType !== 'video'
          );
          const currentData = videoItem.data;
          video.data = [...currentData, ...video.data];
          event.content = [...event.content, video];
        } else if (video.data) {
          event.content = [...event.content, video];
        }
      }

      touchQuestModified(nextQuest);

      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    case REMOVE_EVENT_VIDEO: {
      const targetQuest = (state.quests || []).find(
        (quest) => String(quest.id) === String(action.questId)
      );
      if (!targetQuest) return state;
      nextQuest = { ...targetQuest };
      const event = (nextQuest.events || []).find(
        (e) => String(e.id) === String(action.eventId)
      );
      if (event && event.content) {
        const currentVideos = event.content.filter(
          (item) => item.contentType === 'video'
        );
        if (currentVideos.length) {
          const [firstVideo] = currentVideos;
          const currentVideoObj = { ...firstVideo };
          event.content = event.content.filter(
            (item) => item.contentType !== 'video'
          );
          currentVideoObj.data = currentVideoObj.data.filter(
            (img, i) => i !== action.id
          );
          if (currentVideoObj.data.length) {
            event.content = [...event.content, currentVideoObj];
          }
        }
      }
      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    case RECEIVE_STICKERS_URL: {
      const { stickerId } = action;
      nextQuest = copyQuest(state, action.questId);
      if (!nextQuest) return state;
      const event = findEvent(nextQuest.events, action.eventId);
      if (event) {
        event.content = editEventContent(
          event.content,
          'sticker',
          (stickers) => {
            const index =
              stickers.data.length > stickerId
                ? stickerId
                : stickers.data.length;
            stickers.data.splice(index, 0, ...action.stickers);
            return stickers;
          }
        );
      }

      touchQuestModified(nextQuest);

      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    case REMOVE_EVENT_STICKER: {
      nextQuest = copyQuest(state, action.questId);
      if (!nextQuest) return state;
      const event = findEvent(nextQuest.events, action.eventId);
      if (event && event.content) {
        event.content = editEventContent(
          event.content,
          'sticker',
          ({ data, ...sticker }) => ({
            ...sticker,
            data: data.filter((url, i) => i !== action.imageId),
          })
        );
      }

      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    case REORDER_EVENT_STICKER: {
      const { imageId, newImageId, isUpload } = action;
      nextQuest = copyQuest(state, action.questId);
      if (!nextQuest) return state;
      const event = findEvent(nextQuest.events, action.eventId);
      if (event && event.content && !isUpload) {
        event.content = editEventContent(
          event.content,
          'sticker',
          (stickers) => {
            const { length } = stickers.data;
            if (length >= newImageId && length > imageId) {
              const tmpImage = stickers.data.splice(imageId, 1)[0];
              stickers.data.splice(newImageId, 0, tmpImage);
            }

            return stickers;
          }
        );
      }

      return {
        ...state,
        quests: state.quests.map((quest) =>
          quest.id === action.questId ? nextQuest : quest
        ),
      };
    }

    default:
      return null;
  }
}
